import React from "react";
import classes from "./ModalFooter.scss";
import { Button, Tooltip } from "@toddle-edu/ds-web";

const ModalFooter = props => {
  const {
    onClickButton1,
    onClickButton2,
    leftElement,
    buttonLabel1,
    buttonLabel2,
    isDisabledButton1,
    isDisabledButton2,
    containerStyle,
    showButton1,
    showButton2,
    button1Size,
    button2Size,
    button1Variant,
    button2Variant,
    button1TooltipProps,
    button2TooltipProps,
    button1Type,
    button2Type,
    rightContainerStyle,
    rightCentreComponent,
    shortcut,
    dsVersion,
    testId,
  } = props;

  return (
    <footer className={classes.footerContainer} style={containerStyle}>
      {leftElement && <div>{leftElement}</div>}
      <div className={classes.rightContainer} style={rightContainerStyle}>
        {showButton1 && (
          <Tooltip {...button1TooltipProps}>
            <Button
              disabled={isDisabledButton1}
              variant={button1Variant}
              onClick={onClickButton1}
              size={button1Size}
              type={button1Type}
              dsVersion={dsVersion}
              testId={`${testId}-button1`}
            >
              {buttonLabel1}
            </Button>
          </Tooltip>
        )}
        {rightCentreComponent}
        {showButton2 && (
          <Tooltip {...button2TooltipProps}>
            <Button
              disabled={isDisabledButton2}
              variant={button2Variant}
              onClick={onClickButton2}
              size={button2Size}
              type={button2Type}
              shortcut={shortcut}
              dsVersion={dsVersion}
              testId={`${testId}-button2`}
            >
              {buttonLabel2}
            </Button>
          </Tooltip>
        )}
      </div>
    </footer>
  );
};

ModalFooter.defaultProps = {
  isDisabledButton1: false,
  isDisabledButton2: false,
  showButton1: true,
  showButton2: true,
  button1Size: "medium",
  button2Size: "medium",
  button1TooltipProps: {},
  button2TooltipProps: {},
  button1Type: "fill",
  button2Type: "fill",
  button1Variant: "outlined-subtle",
  button2Variant: "progressive",
  rightCentreComponent: null,
  shortcut: {},
  dsVersion: "1.0",
};

export default ModalFooter;
